// extracted by mini-css-extract-plugin
module.exports = {"pageTabs":"PageTabs_pageTabs__e_VbZ"};